module.exports = __webpack_public_path__ + "register/img/cvc_helper.b2618058.jpg";